import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';

class ProductFormController extends Controller {
  connect() {
    this.isValid = false;

    this.toggleAddToCartButton();
  }

  hasConfigurableProductCheckboxSelected() {
    return this.configurableProductCheckboxTargets.filter((c) => c.checked).length > 0;
  }

  onConfigurableProductCheckboxChange({ target }) {
    const wrapper = target.closest('[data-target="product-form.configurableProductWrapper"]');
    const configurableProductCheckboxes = toArray(wrapper.querySelectorAll('[data-target="product-form.configurableProductCheckbox"]'));
    const noConfigurableProductCheckbox = wrapper.querySelector('[data-target="product-form.noConfigurableProductCheckbox"]');
    const oneConfigurableProductSelected = configurableProductCheckboxes
      .filter((checkbox) => checkbox.checked)
      .length > 0;

    noConfigurableProductCheckbox.checked = !oneConfigurableProductSelected;

    this.toggleAddToCartButton();
  }

  onNoConfigurableProductCheckboxChange({ target }) {
    const wrapper = target.closest('[data-target="product-form.configurableProductWrapper"]');
    const configurableProductCheckboxes = toArray(wrapper.querySelectorAll('[data-target="product-form.configurableProductCheckbox"]'));

    configurableProductCheckboxes.forEach((checkbox) => { checkbox.checked = false; });

    this.toggleAddToCartButton();
  }

  toggleAddToCartButton() {
    if (!this.hasConfigurableProductCheckboxTarget) {
      this.addToCartButtonTarget.disabled = false;

      return;
    }

    const canSubmit = (
      this.hasConfigurableProductCheckboxSelected()
      || this.noConfigurableProductCheckboxTarget.checked
    );

    this.hasSelectedAccessoriesTarget.value = this.hasConfigurableProductCheckboxSelected() ? '1' : '0';
    this.errorOutputTarget.style.display = canSubmit ? 'none' : 'block';
    this.addToCartButtonTarget.disabled = !canSubmit;
  }
}

ProductFormController.targets = [
  'errorOutput',
  'addToCartButton',
  'hasSelectedAccessories',
  'configurableProductWrapper',
  'configurableProductCheckbox',
  'noConfigurableProductCheckbox',
];

export default ProductFormController;
